import type { BookingSearch } from "@/lib/bookingSearch"
import { fetchBusinesses } from "@/lib/bookingSearch/fetchBusinesses"
import type { ErrorHandling } from "@/lib/error_handling"
import { Mirror } from "@/lib/mirror"

export const performBookingSearch = async ({
  keys,
  onFailure,
}: {
  keys: BookingSearch.Cache.Keys
  onFailure: ErrorHandling.Functions.OnFatalError
}) => {
  return Mirror.build(await fetchBusinesses({ keys, onFailure }))
}
